module.exports = __webpack_public_path__ + "img/ceara_background_768.44349a8b.svg";